var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"selection"}},[_c('OrderMenu'),(!_vm.isPaid)?_c('section',{staticClass:"container-fluid my-5"},[_c('OrderPayment')],1):_c('GallerySection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }